import { render, staticRenderFns } from "./VideoDisplayWidget.vue?vue&type=template&id=48432168&scoped=true&"
import script from "./VideoDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./VideoDisplayWidget.vue?vue&type=script&lang=js&"
import style0 from "./VideoDisplayWidget.vue?vue&type=style&index=0&id=48432168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48432168",
  null
  
)

export default component.exports